// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2Mjup","col":"Table_col__1eq67","fulfillmentStatus":"Table_fulfillmentStatus__2AtfV","emailCol":"Table_emailCol__2YnzZ"};